import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { useConfigSettings } from '~/hooks/useConfigSettings';
import { useStoreId } from '~/providers/StoreUserProvider';

export const claimOrderLineageQueryKey = (storeId: string, claimId: number) =>
  ['claimOrderLineage', storeId, claimId] as const;

/**
 * The chain of orders and claims behind this one. Only fetched for an exchange of
 * an exchange, since anything else has no chain to walk.
 */
export function useClaimOrderLineage() {
  const claim = useClaim();
  const storeId = useStoreId();
  const { data: isClaimLineageEnabled } = useConfigSettings(
    ({ variantExchanges }) => variantExchanges.isClaimLineageEnabled,
  );

  return useQuery({
    queryKey: claimOrderLineageQueryKey(storeId, claim.id),
    queryFn: () => api.store(storeId).claim(`${claim.id}`).orderLineage(),
    enabled:
      !!isClaimLineageEnabled && claim.originalStoreOrder.isExchangeOfExchange,
    // stale time of 1 minute
    staleTime: 1 * 60 * 1000,
  });
}
